import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import "./ProjectItem.css";

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
}));

function ProjectItem({ title, link, note, src, lang, description }) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [showDescription, setShowDescription] = useState(true);

  const handleExpandClick = () => {
    setExpanded(!expanded);
    setShowDescription(!showDescription);
  };

  return (
    <div className="projectItem">
      <ScrollAnimation animateIn="animate__bounceInLeft" animateOnce>
        <Card className="projectItem__card">
          <Typography className="projectItem__title">{title}</Typography>
          <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
              {lang}
            </Typography>
          </CardContent>
          <img className="projectItem__image" src={src} alt="" />
          <CardActions disableSpacing>
            {showDescription && (
              <Typography className="projectItem__readDescription">
                Read the Desciption
              </Typography>
            )}
            <IconButton
              className={clsx(classes.expand, {
                [classes.expandOpen]: expanded,
              })}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </IconButton>
          </CardActions>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <CardContent>
              <Typography className="projectItem__descriptionHeader" paragraph>
                Description :
              </Typography>
              {note && (
                <Typography className="projectItem__descriptionNote">
                  Note: Use Desktop or Desktop Site Mode to open this site for
                  better experience..
                </Typography>
              )}
              <Typography className="projectItem__descriptionLink">
                Demo Link :{" "}
                <span onClick={() => window.open(link)}>{link}</span>
              </Typography>
              <Typography className="projectItem__descriptionText" paragraph>
                {description}
              </Typography>
            </CardContent>
          </Collapse>
        </Card>
      </ScrollAnimation>
    </div>
  );
}

export default ProjectItem;
